module.exports = __webpack_public_path__ + "img/39_16.26918f06.png";